import { type PropsWithChildren } from "react";
import { MsalInitializer } from "../../MsalInitializer.tsx";
import { SessionProvider } from "../SessionProvider.tsx";

export function AuthenticatedProviders({ children }: PropsWithChildren) {
    return (
        <MsalInitializer>
            <SessionProvider>{children}</SessionProvider>
        </MsalInitializer>
    );
}
